export default "__VITE_ASSET__cd748201__"